import { Routes } from '@angular/router';
import { userGuard } from './core/guards/user.guard';
import { notUserGuard } from './core/guards/notUser.guard';
import { userResolver } from './core/resolvers/user.resolver';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [notUserGuard],
    loadComponent: () => import('./login/login').then((m) => m.Login),
  },
  {
    path: '',
    canActivate: [userGuard],
    resolve: { user: userResolver },
    loadComponent: () =>
      import('./main/main-layout/main-layout').then((m) => m.MainLayout),
    loadChildren: () =>
      import('./main/main.routes').then((m) => m.mainRoutes),
  },
];
